/**
 * @generated SignedSource<<10c719c98390f5498900124b91a968f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type deploymentTooltipContent_softwareReleasesLaunchCard_deployment$data = {
  readonly environment: {
    readonly category: DevOpsEnvironmentCategory;
    readonly displayName: string | null | undefined;
  };
  readonly issueIds: ReadonlyArray<string> | null | undefined;
  readonly lastUpdated: AGG$DateTime;
  readonly state: DeploymentState;
  readonly " $fragmentType": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment";
};
export type deploymentTooltipContent_softwareReleasesLaunchCard_deployment$key = {
  readonly " $data"?: deploymentTooltipContent_softwareReleasesLaunchCard_deployment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deploymentTooltipContent_softwareReleasesLaunchCard_deployment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "deploymentTooltipContent_softwareReleasesLaunchCard_deployment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "state"
      },
      "action": "THROW",
      "path": "state"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOpsEnvironment",
        "kind": "LinkedField",
        "name": "environment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "category"
            },
            "action": "THROW",
            "path": "environment.category"
          }
        ]
      },
      "action": "THROW",
      "path": "environment"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "lastUpdated"
      },
      "action": "THROW",
      "path": "lastUpdated"
    },
    {
      "kind": "ScalarField",
      "name": "issueIds"
    }
  ],
  "type": "DeploymentSummary"
};

(node as any).hash = "f474689f31fc91d3dfb760e1b811618d";

export default node;
